(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('bagActions', {
            templateUrl: 'app/admin/bag/bag-actions/bag-actions.html',
            controller: bagActionsController,
            bindings: {
                bag: '<',
                resultFunc: '&?',
                downloadFunc: '&?',
                whatsappFunc: '&?',
                copyUrl: '<',
                navigateUrl: '<',
            },
            controllerAs: 'vm'
        });

    /** @ngInject */
    function bagActionsController($window, $translate, toastr, BagService) {
        var vm = this;

        vm.$onInit = init;

        vm.copyUrlToClipboard = function () {
            copyToClipboard(vm.copyUrl).then(function () {
                toastr.success($translate.instant('bag.success.copied'));
            });
        }

        vm.showResults = function () {
            if (vm.resultFunc) {
                vm.resultFunc(vm.bag);
            }
        }

        vm.downloadPdf = function () {
            if (vm.downloadFunc) {
                vm.downloadFunc(vm.bag);
            }
        }

        vm.navigate = function () {
            if (vm.navigateUrl) {
                window.open(vm.navigateUrl, '_blank');
            }
        }

        function init() {
            vm.resultFunc = vm.resultFunc ? vm.resultFunc : undefined;
            vm.downloadFunc = vm.downloadFunc ? vm.downloadFunc : undefined;
            vm.whatsappFunc = vm.whatsappFunc ? vm.whatsappFunc : undefined;
            vm.copyUrl = vm.copyUrl ? vm.copyUrl : '';
            vm.navigateUrl = vm.navigateUrl ? vm.navigateUrl : '';
            vm.bag.whatsappText = BagService.getBagWhatsAppText(vm.bag);
        }
    }
})();
